import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, AlertTriangle } from "lucide-react";

// This component requires admin billing tables that are not yet configured.
// The required tables (user_billing_profiles, admin_billing_actions, billing_transactions)
// need to be created before this functionality can be used.

export function AdminBillingPanel() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Shield className="w-5 h-5" />
          Admin Billing Management
        </CardTitle>
        <CardDescription>
          Manage user billing profiles, adjust balances, and grant free minutes
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <AlertTriangle className="w-12 h-12 text-muted-foreground mb-4" />
          <p className="text-muted-foreground">
            Admin billing tables are not configured.
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            The required database tables (user_billing_profiles, admin_billing_actions) 
            need to be created to enable this functionality.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
